import React from 'react';
import { Skeleton } from 'antd';

export default () => {
  return (
    <>
      <div className={'container'}>
        <Skeleton active />
        <Skeleton active />
      </div>
    </>
  );
};
